import React, { Fragment } from 'react';

import { BASE_APP_URL } from 'app/developer-v3/constants';
import { deduplicateSlashes } from 'app/developer-v3/utils';
import HealthScoreMeter from './HealthScoreMeter';
import HealthStats from './HealthStats';
import Module, { StatTextLine } from './Module';
import { HEALTH_SCORE_MAP, HEALTH_TIER_MESSAGES } from './constants';

import type {
  PartnerDashboard,
  PartnerTiersType,
} from 'app/developer-v3/types/partnerDashboard';
import { Link, Spacer, Text } from '@zapier/design-system';

type Props = {
  appId: number;
  health: PartnerDashboard['health'];
  isBeta?: boolean;
  partnerTier: PartnerTiersType;
};

const HealthScore = (props: Props) => {
  const { appId, health, isBeta, partnerTier } = props;
  // TODO: We won't have to check isBeta once BETA status is a valid tier on the data side
  const healthMessage = isBeta
    ? HEALTH_TIER_MESSAGES.BETA[health.currentScore]
    : HEALTH_TIER_MESSAGES[partnerTier][health.currentScore];

  return (
    <Module
      figure={
        <HealthScoreMeter
          height={isBeta ? undefined : 45}
          score={health.currentScore}
          width={isBeta ? undefined : 90}
        />
      }
      help="This score is determined by the number of bugs and feature requests your integration has and how responsive your team is to them."
      isBeta={isBeta}
      stats={{
        current: HEALTH_SCORE_MAP[health.currentScore],
        lines: <StatTextLine>{healthMessage}</StatTextLine>,
        title: 'Health score this quarter',
      }}
      title="Health score"
    >
      {isBeta && (
        <Fragment>
          <HealthStats {...health.statistics} />
          <Spacer height={20} />
        </Fragment>
      )}
      <Text>
        Review your{' '}
        <Link href={deduplicateSlashes(`${BASE_APP_URL}/app/${appId}/issues`)}>
          prioritized list{' '}
        </Link>
        of feature requests and bugs.
      </Text>
    </Module>
  );
};

export default HealthScore;
